import { AbstractControl, ValidatorFn } from '@angular/forms';

export function whitespace(): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
        if (!(c.value && (c.value as string).trim())) {
            return { whitespace: true };
        }
        return null;
    };
}
